namespace $ { $mol_style_attach( "shm/hotkey/hotkey.view.css",
 "[shm_hotkey] { display: contents; }\n[shm_hotkey_style] { display: none; }\n"
) }